export default {
    namespaced: true,
    state: () => ({
        ThongTinKhaiBaoVe: {
            InVe: true,
            BenDen: null,
            BienKiemSoat: null,
            GioXuatBen: new Date(),
            SoLuongVe: 1,
            MaTuyen: null,
        },
    }),
    getters: {},

    mutations: {
        Set: (state, { key, data }) => {
            state[key] = data;
        },
        Reset_ThongTinKhaiBaoVe: (state) => {
            state.ThongTinKhaiBaoVe = {
                InVe: true,
                BenDen: null,
                BienKiemSoat: null,
                GioXuatBen: new Date(),
                SoLuongVe: 1,
                MaTuyen: null,
            };
        },
    },

    actions: {
        async ThucHienKhaiBaoVe(store) {
            try {
                let dataPost = {
                    BenDen: store.state.ThongTinKhaiBaoVe.BenDen,
                    BienKiemSoat: store.state.ThongTinKhaiBaoVe.BienKiemSoat,
                    GioXuatBen: store.state.ThongTinKhaiBaoVe.GioXuatBen,
                    SoLuongVe: store.state.ThongTinKhaiBaoVe.SoLuongVe,
                    MaTuyen: store.state.ThongTinKhaiBaoVe.MaTuyen,
                };
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("urlKhaiBaoVe.ThucHienKhaiBaoVeNoiBo")
                ).Post(dataPost);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
        async LayPhieuInVe(store, DanhSachVe) {
            try {
                let dataPost = {
                    DanhSachVe: DanhSachVe,
                };
                let rs = await this.$Core.Api.Make(
                    this.$i18n.global.t("urlKhaiBaoVe.LayPhieuInVe")
                ).Post(dataPost);
                return rs.Data;
            } catch (error) {
                console.log("error", error);
            }
        },
    },
};
